import { useGetGlobalSearchResultsPresenter } from './useGetGlobalSearchResultsPresenter'
import { GlobalSearchModal } from '../../views/GlobalSearchModal/GlobalSearchModal'

interface IGetGlobalSearchResultsPresenterProps {
  isOpen: boolean
  onClose: () => void
}

export const GetGlobalSearchResultsPresenter = ({
  isOpen,
  onClose,
}: IGetGlobalSearchResultsPresenterProps) => {
  const {
    commands: { onQueryChange, onSubmit, onRecentItemClick, onResultItemClick },
    data: { query, recentItems, resultItems, inputRef },
    states: { showEnterHint, contentState },
  } = useGetGlobalSearchResultsPresenter()

  return (
    <GlobalSearchModal
      isOpen={isOpen}
      query={query}
      showEnterHint={showEnterHint}
      contentState={contentState}
      recentItems={recentItems}
      resultItems={resultItems}
      inputRef={inputRef}
      onClose={onClose}
      onQueryChange={onQueryChange}
      onSubmit={onSubmit}
      onRecentItemClick={onRecentItemClick}
      onResultItemClick={onResultItemClick}
    />
  )
}
